import React, { useContext } from 'react';
import { func } from 'prop-types';

// Components
import { Box, Typography } from '@mui/material';
import Buttons from '../../components/Buttons';
import SummaryContent from '../../components/SummaryContent';

// Context
import { SequencingWizardContext } from '../../SequencingWizardContext';

const LastStep5 = ({ prev, next }) => {
  const {
    data: { changeList, inventoryOwners = [] },
  } = useContext(SequencingWizardContext);

  const lastInventoryOwner = `${
    inventoryOwners[inventoryOwners.length - 1]?.companyCustomerIdName
  } ${inventoryOwners[inventoryOwners.length - 1]?.nameLong}`;

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          // height of other components is 157px
          // prevents progress bar from looking off
          height: 'calc(100% - 157px)',
          overflowY: 'auto',
          pt: 3,
        }}
      >
        <Box mb={3} px={3}>
          <Typography sx={{ mb: 2, textAlign: 'center' }} variant="h6">
            Confirm New Sequence Placement
          </Typography>
          <Typography
            sx={{
              marginBottom: '16px',
            }}
            variant="body1"
          >
            {lastInventoryOwner} will be moved to the last spot in the Authorization Sequences for
            the following locations and products.
          </Typography>
          <Typography sx={{ textAlign: 'center' }} variant="body1">
            There could be a total of {changeList.length} change{changeList.length > 1 ? 's' : ''}.
            This change can take up to 15 minutes to take affect at all locations.
          </Typography>
        </Box>
        <SummaryContent inventoryOwnerSubtitle="Selected Inventory Owner" />
      </Box>
      <Buttons
        disabled={false}
        handleLeftButtonClick={prev}
        handleRightButtonClick={next}
        leftLabel="Back"
        loadingData={false}
        rightLabel="Submit"
      />
    </>
  );
};

LastStep5.propTypes = {
  next: func.isRequired,
  prev: func.isRequired,
};

export default LastStep5;
